import { useEffect, useState, Fragment } from 'react';
import { useSelector, useDispatch } from "react-redux";

 
import { DataGrid, GridCellEditStopReasons, useGridApiContext } from '@mui/x-data-grid';
import {
    Button, FormControl, FormGroup, TextField, Select, MenuItem, InputLabel, Box, NativeSelect, IconButton, Dialog, DialogContent,
    DialogTitle, DialogContentText, DialogActions, Card, CardContent, Typography, CardActions
} from "@mui/material";
import { CreateIcon, DeleteIcon, AddIcon, } from '@mui/icons-material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';


import React, { PureComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


const data = [
    {
        name: 'Page A',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    },
    {
        name: 'Page B',
        uv: 3000,
        pv: 1398,
        amt: 2210,
    },
    {
        name: 'Page C',
        uv: 2000,
        pv: 9800,
        amt: 2290,
    },
    {
        name: 'Page D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Page E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Page F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Page G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
];

const GraphInput = () => {
    const [values, setValues] = React.useState({
        amount: '',
        password: '',
        weight: '',
        weightRange: '',
        showPassword: false,
    });

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };

    const handleClickShowPassword = () => {
        setValues({
            ...values,
            showPassword: !values.showPassword,
        });
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', paddingBottom: '50px' }}>
            <div>
                <FormControl sx={{ m: 1, width: '22%' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">Adelanto</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={'text'}
                        value={values.adelanto}
                        onChange={handleChange('adelanto')}
                        label="Adelanto"
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '22%' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">Cuotas</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={'text'}
                        value={values.cuotas}
                        onChange={handleChange('cuotas')}
                        label="Cuotas"
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '22%' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">Prima</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={'text'}
                        value={values.prima}
                        onChange={handleChange('prima')}
                        label="Prima"
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '22%' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">Valor</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-password"
                        type={'text'}
                        value={values.prima}
                        onChange={handleChange('prima')}
                        label="Prima"
                    />
                </FormControl>
                <Button>Calcular</Button>
            </div>
        </Box>
    );
}


const Graph = () => {
    return (
        <ResponsiveContainer width="100%" height="100%">
            <LineChart
                width={500}
                height={300}
                data={data}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />
                <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
            </LineChart>
        </ResponsiveContainer>
    );
}


const CalculadoraCat = () => {

    return (
        <Card sx={{ minWidth: 275, height: 800 }}>
            <CardContent sx={{ height: 450 }} >
            <Typography variant="h5" component="div" sx={{ minWidth: 275, margin: '10px' }}>
                Calculadora Cuotas:
            </Typography>
                <GraphInput></GraphInput>
                <Graph></Graph>
            </CardContent>
            <CardActions>
                <Button size="small"></Button>
            </CardActions>
        </Card>
    )
}

export default CalculadoraCat